var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogopackage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F36F45"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 14.2666L13 10.8066",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 18.6667V13.3333C21.9998 13.0995 21.938 12.8699 21.821 12.6675C21.704 12.465 21.5358 12.2969 21.3333 12.18L16.6667 9.51335C16.464 9.39633 16.234 9.33472 16 9.33472C15.766 9.33472 15.536 9.39633 15.3333 9.51335L10.6667 12.18C10.4642 12.2969 10.296 12.465 10.179 12.6675C10.062 12.8699 10.0002 13.0995 10 13.3333V18.6667C10.0002 18.9005 10.062 19.1301 10.179 19.3326C10.296 19.535 10.4642 19.7031 10.6667 19.82L15.3333 22.4867C15.536 22.6037 15.766 22.6653 16 22.6653C16.234 22.6653 16.464 22.6037 16.6667 22.4867L21.3333 19.82C21.5358 19.7031 21.704 19.535 21.821 19.3326C21.938 19.1301 21.9998 18.9005 22 18.6667Z",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1799 12.6399L15.9999 16.0066L21.8199 12.6399",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 22.72V16",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogopackage);
export default __webpack_public_path__ + "static/media/logopackage.7b8ffeec89cb1e0a809b11dfe26693b1.svg";
export { ForwardRef as ReactComponent };